import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { I18nService } from '../../services/i18n-service';
import { takeUntil, Subject } from 'rxjs';

@Component({
  selector: 'app-success-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './success-page.html',
  styleUrl: './success-page.scss',
})
export class SuccessPage implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private loginUrl: string = '';
  currentTranslations: any = {};

  constructor(public i18n: I18nService) {
    document.body.classList.add('no-scroll');
  }

  ngOnInit(): void {
    // Initialize with current language from I18nService
    const currentLang = this.i18n.getCurrentLanguage();
    this.i18n.setLanguage(currentLang);

    this.i18n.translations$
      .pipe(takeUntil(this.destroy$))
      .subscribe(translations => {
        this.currentTranslations = translations;
        this.loginUrl = this.i18n.getLocalizedLoginUrl(environment.portalLoginUrl);
      });
  }

  goToLogin(): void {
    window.location.href = this.loginUrl;
  }

  ngOnDestroy(): void {
    document.body.classList.remove('no-scroll');
    this.destroy$.next();
    this.destroy$.complete();
  }
}
